<div class="container">
  <h2 class="page-header">Borden</h2>
  <div class="form-title">
    <div class="form-title-text">
      <span>Item</span> <span class="pull-right">Acties</span>
    </div>
  </div>
  <div class="available-lists">
    <div
      class="available-list d-flex"
      [routerLink]="['/signs-portal', 'signs']"
    >
      <span class="list-item flexer">Borden</span>
      <button class="edit-button btn btn-sm pull-right" mat-icon-button>
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </div>
    <div
      class="available-list d-flex"
      [routerLink]="['/signs-portal', 'titles']"
    >
      <span class="list-item flexer">Titels</span>
      <button class="edit-button btn btn-sm pull-right" mat-icon-button>
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </div>
    <div
      class="available-list d-flex"
      [routerLink]="['/signs-portal', 'phonenumbers']"
    >
      <span class="list-item flexer">Telefoonnummers</span>
      <button class="edit-button btn btn-sm pull-right" mat-icon-button>
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </div>
    <div
      class="available-list d-flex"
      [routerLink]="['/signs-portal', 'stickers']"
    >
      <span class="list-item flexer">Stickers</span>
      <button class="edit-button btn btn-sm pull-right" mat-icon-button>
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </div>
  </div>
</div>
